<ngx-spinner type="ball-spin-clockwise"></ngx-spinner>
<!--begin::Header-->
<div class="d-flex flex-column flex-root">
  <!--begin::Page-->
  <div class="page d-flex flex-row flex-column-fluid">
    <app-sidebar></app-sidebar>
    <!--begin::Wrapper-->
    <div class="wrapper d-flex flex-column flex-row-fluid ps-0" id="kt_wrapper">
      <div class="w-100" style="min-height: 80vh">
        <app-header></app-header>
        <!--begin::Content-->
        <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
          <!--begin::Container-->
          <div class="container-fluid" id="kt_content_container">
            <div>
              <router-outlet></router-outlet>
            </div>
            <!--end::Row-->
          </div>
          <!--end::Container-->
        </div>
        <!--end::Content-->
        <app-footer></app-footer>
      </div>
      
    </div>
    <!--end::Wrapper-->
  </div>
  <!--end::Page-->
</div>
<!--end::Header-->